import {postMethod} from '~/api'

async function post(request) {
    return await postMethod('/api/companies/massEdit', request)
}

export {post}
